module.exports = __webpack_public_path__ + "static/media/bw-logo-white-mobile.a2a313e4.svg";